import { load } from './Controllers/BaseController';
import MenuController from './Controllers/MenuController';
import LanguageController from './Controllers/LanguageController';
import CookieBannerController from './Controllers/CookieBannerController';
import LazyLoaderController from './Controllers/LazyLoaderController';
import IframeController from './Controllers/IframeController';
import FirebaseController from './Controllers/FirebaseController';
import SearchController from './Controllers/SearchController';
import ToggleController from './Controllers/ToggleController';
import AnimationController from './Controllers/AnimationController';

export default load([
  MenuController,
  LanguageController,
  CookieBannerController,
  LazyLoaderController,
  IframeController,
  FirebaseController,
  SearchController,
  ToggleController,
  AnimationController
]);
